import { render, staticRenderFns } from "./phonePlan.vue?vue&type=template&id=d9bd6c2a&scoped=true"
import script from "./phonePlan.vue?vue&type=script&lang=js"
export * from "./phonePlan.vue?vue&type=script&lang=js"
import style0 from "./phonePlan.vue?vue&type=style&index=0&id=d9bd6c2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bd6c2a",
  null
  
)

export default component.exports